export const LOCALES = ["fr", "en"] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "fr";

/** Extract locale from a pathname like "/fr/dashboard" → "fr" */
export function getLocaleFromPath(pathname: string): Locale {
  const match = pathname.match(/^\/(fr|en)(?:\/|$)/);
  return (match ? match[1] : DEFAULT_LOCALE) as Locale;
}

/**
 * Prepend locale to an absolute path if not already present.
 *
 * Always-prefix model (post-2026-05-15 overhaul): both /fr/* and /en/* are
 * always prefixed. localePrefix: 'always' is the next-intl routing mode.
 */
export function localePath(path: string, locale: Locale): string {
  if (!path.startsWith("/")) return path;
  if (path.match(/^\/(fr|en)(?:\/|$)/)) return path;
  return `/${locale}${path}`;
}

/** Strip locale prefix from a pathname: "/fr/dashboard" → "/dashboard" */
export function stripLocale(pathname: string): string {
  return pathname.replace(/^\/(fr|en)(\/|$)/, "$2") || "/";
}
